import { render } from "./CheckoutArea.vue?vue&type=template&id=1c83995f"
import script from "./CheckoutArea.vue?vue&type=script&lang=js"
export * from "./CheckoutArea.vue?vue&type=script&lang=js"

import "./CheckoutArea.vue?vue&type=style&index=0&id=1c83995f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__